import styled from 'styled-components';
import { coreTokens } from '../../../core';
import { FileTypes, getFileType } from '../../../utils/file_type';
import { Illustration } from '../../illustration';
import { FileWorkerStaleDuckType } from '../_file_worker_stale_duck_type';

const elements = {
	container: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: ${coreTokens.spacing.x1};
		gap: ${coreTokens.spacing.x2};
		max-width: 400px;
		width: 100%;
		text-align: center;
		word-break: break-word;
		font: ${coreTokens.text.label.regular};
	`,
	illustration: styled.div`
		width: ${coreTokens.size.x9};
		height: ${coreTokens.size.x9};
	`,
};

interface NoPreviewProps {
	file: FileWorkerStaleDuckType;
}

export function FileViewerItemNoPreview({ file }: NoPreviewProps): JSX.Element {
	let preview: JSX.Element;

	switch (getFileType(file.fileType)) {
		case FileTypes.Doc:
			preview = <Illustration type='fileWord' />;
			break;
		case FileTypes.Pdf:
			preview = <Illustration type='filePdf' />;
			break;
		case FileTypes.Xslx:
			preview = <Illustration type='fileExcel' />;
			break;
		default:
			preview = <Illustration type='fileOtherFormat' />;
	}

	return (
		<elements.container>
			<elements.illustration>{preview}</elements.illustration>
			<span>{file.fileName}</span>
		</elements.container>
	);
}
